import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import CategoryGrid from './components/CategoryGrid';
import GuidesSection from './components/GuidesSection';
import CTASection from './components/CTASection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuy.team';

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'VigorBuy.team',
      url: siteUrl,
      description: 'The ultimate VigorBuy Spreadsheet directory for fashion finds, shoes, streetwear, and accessories.',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    });
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, [siteUrl]);

  return (
    <main>
      <Navbar />
      <Hero />
      <TrustBar />
      <CategoryGrid />
      <GuidesSection />
      <CTASection />
      <Footer />
    </main>
  );
}